exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2l2-NjRdGvdW2Y{width:100%;display:flex;align-items:center;padding:8px}._2l2-NjRdGvdW2Y ._2la9tKgedmrYG8{flex-grow:0;border-radius:3px}._2l2-NjRdGvdW2Y ._2hqGI2VEG5jkAt{display:flex;flex-direction:column;flex-grow:1;max-width:40%}._2l2-NjRdGvdW2Y ._2hqGI2VEG5jkAt ._302EjxR2X04vGs{padding-left:8px;font-size:16px;font-weight:700}._2l2-NjRdGvdW2Y ._2hqGI2VEG5jkAt ._1YbVDaUdg6297W{padding-left:8px;color:#5e6c84}._2l2-NjRdGvdW2Y .SF02wxSh5DcyL7{display:flex;flex-direction:column;padding-left:32px}._2l2-NjRdGvdW2Y .SF02wxSh5DcyL7 ._3-xVgHwdz0lCcQ{font-size:12px;color:#5e6c84}._2l2-NjRdGvdW2Y .SF02wxSh5DcyL7 ._3-xVgHwdz0lCcQ a{display:inline-block;color:#5e6c84}._2l2-NjRdGvdW2Y ._1ANVC-CII7JmNj{margin-left:auto}._2l2-NjRdGvdW2Y ._1ANVC-CII7JmNj button{margin-left:8px}._2l2-NjRdGvdW2Y ._1ANVC-CII7JmNj button:first-child{margin-left:0}", ""]);

// exports
exports.locals = {
	"pendingTeamItem": "_2l2-NjRdGvdW2Y",
	"teamAvatar": "_2la9tKgedmrYG8",
	"requestInfo": "_2hqGI2VEG5jkAt",
	"teamName": "_302EjxR2X04vGs",
	"requestor": "_1YbVDaUdg6297W",
	"members": "SF02wxSh5DcyL7",
	"membersDetails": "_3-xVgHwdz0lCcQ",
	"actions": "_1ANVC-CII7JmNj"
};